import * as types from '../actiontypes';

export function updateDisplayData(engagements, entities, orgChart, maintainSelected = false, body = null) {
	return {
		type: types.UPDATE_DISPLAY_DATA,
		engagements,
		entities,
		orgChart,
		maintainSelected,
		body
	};
}

export function updateTreeOrg(treeOrgChart) {
	return {
		type: types.UPDATE_TREE_ORG,
		treeOrgChart
	};
}
